import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofBoxes = () => {

  const servicesFaqData = [
    { 
        question: "What customization options are available for box printing?", 
        answer: "Printingy offers extensive customization options for printing boxes and padded boxes, including sizes, shapes, materials, and finishes. Our services include customized packaging boxes with logos, vibrant graphics, and tailored layouts. Whether you need corrugated boxes, padded boxes, or speciality packaging, we ensure your designs are functional and visually appealing."
    },
    { 
        question: "Does Printingy handle bulk orders for box printing?", 
        answer: "Yes, Printingy specializes in bulk Custom Packaging Boxes Printing, catering to businesses with large-scale needs. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for retail, e-commerce, and corporate packaging. Our efficient production processes guarantee reliable and timely delivery for all bulk orders."
    },
    { 
        question: "What industries benefit from custom box printing services?", 
        answer: "Custom box printing services are widely used in retail, manufacturing, food and beverage, and e-commerce industries. Businesses rely on printing corrugated box solutions for shipping, while box design printing is used for branding and product packaging. Printingy provides tailored solutions to meet the unique requirements of each industry."
    },
    { 
        question: "What materials are used for box printing?", 
        answer: "We use high-quality materials for custom printing of boxes, including cardboard, corrugated board, and padded options. Finishes such as matte, glossy, or UV coating enhance durability and visual appeal. These materials ensure your packaging is functional and aesthetically pleasing, suitable for shipping, retail, or gifting purposes."
    },
    { 
        question: "Does Printingy provide design assistance for box printing?", 
        answer: "Yes, our box printing press services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From colour selection to typography, we ensure your packaging aligns with your branding."
    },
    { 
        question: "What is the typical turnaround time for box printing?", 
        answer: "Turnaround times for Printing Boxes & Padded depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customized designs or larger volumes, we provide clear timelines and prioritize meeting your deadlines without compromising quality."
    },
    { 
        question: "Are eco-friendly options available for box printing?", 
        answer: "Printingy is committed to sustainability and offers eco-friendly options for customized packaging boxes. To minimize environmental impact, we use recyclable materials, non-toxic inks, and sustainable production methods. These options are ideal for businesses seeking environmentally responsible packaging solutions."
    },
    { 
        question: "What factors should I consider when ordering box printing services?", 
        answer: "Consider the purpose, product dimensions, and branding elements when ordering Custom Packaging Boxes Printing. Selecting the right materials, sizes, and designs ensures your boxes are effective and visually appealing. Printingy’s team guides the process to help you create packaging that meets your needs."
    },
    { 
        question: "How do I place an order for box printing services?", 
        answer: "Placing an order is simple and efficient. Visit our website and select your preferences for printing boxes & padding, including customization options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk box printing cost-effective?", 
        answer: "Bulk Custom Packaging Boxes Printing reduces per-unit costs, making it an economical choice for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk printing services ensure exceptional value while maintaining professional standards."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing of Boxes');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes



  return (
    <div>
       <MetaManager 
  title="Custom Box Printing and Packaging Solutions"
  description="Professional printing of boxes and padded packaging. Bulk custom packaging box printing, corrugated box printing, and box design solutions."
  keywords="Printing of Boxes & Padded,
Custom Packaging Boxes Printing,
Padded box printing,
Boxes & Padded printing,
Box design printing,
Printed packaging box manufacturer,
Customized packaging boxes,
Printing corrugated box,
Custom printing of boxes,
Box printing press"
/>
      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Box and Padded Packaging Printing</h1>
              <h2 className="text-muted">
              Professional printing solutions for customized packaging boxes and designs
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4  shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Boxes and padded packaging are essential for branding, shipping, and product protection. Printingy specializes in Printing of Boxes & Padded, offering premium-quality Custom Packaging Boxes Printing services tailored to your business needs.
          </p>
          
          <p>Our solutions include padded, corrugated, and custom box design printing to suit diverse industries. As a trusted printed packaging box manufacturer, we deliver durable, aesthetically pleasing packaging that enhances brand visibility and ensures product safety.</p>
          <p>With advanced printing technology and bulk order capabilities, Printingy guarantees high-quality and cost-effective packaging solutions. Whether for retail products, e-commerce, or corporate gifting, our custom printing services provide the perfect balance of form and function.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Box Printing and Packaging Solutions</h2>
                <h3 className="large-hed">High-quality, affordable, and durable custom packaging boxes</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional Custom Packaging Boxes Printing tailored to your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable padded box printing for safe and secure packaging.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing of boxes & padded for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant box design printing for impactful branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for sharp details and precise prints.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and sustainable production practices.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted printed packaging box manufacturer for businesses nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/public/assets/img/printedboxes.jpg" // Path relative to the public folder
                  alt="Durable corrugated box printing solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Boxes and Packaging Delivered On Time </h2>
            <h3 className="small-hed">Focus on your products while we handle your box printing needs </h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional Boxes & Padded Printing services. Whether you need customized packaging boxes for retail or bulk padded box printing for shipping, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes guarantee timely delivery, even for large orders. Partner with Printingy for reliable box printing solutions that protect your products and elevate your brand.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofBoxes;
